import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-center align-items-center container-fluid h-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaymentSucceded = _resolveComponent("PaymentSucceded")!
  const _component_PaymentRefused = _resolveComponent("PaymentRefused")!
  const _component_ErrorFromHelloasso = _resolveComponent("ErrorFromHelloasso")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_PaymentSucceded, null, null, 512), [
      [_vShow, _ctx.isReturn() && _ctx.isPaymentSucceded()]
    ]),
    _withDirectives(_createVNode(_component_PaymentRefused, {
      helloassoCheckoutIntentUrl: _ctx.helloassoCheckoutIntentUrl,
      amount: _ctx.totalAmount
    }, null, 8, ["helloassoCheckoutIntentUrl", "amount"]), [
      [_vShow, _ctx.isReturn() && _ctx.isPaymentRefused()]
    ]),
    _withDirectives(_createVNode(_component_ErrorFromHelloasso, {
      helloassoCheckoutIntentUrl: _ctx.helloassoCheckoutIntentUrl,
      amount: _ctx.totalAmount
    }, null, 8, ["helloassoCheckoutIntentUrl", "amount"]), [
      [_vShow, _ctx.isError()]
    ])
  ]))
}